import React, { FC } from 'react';
import {
  MentionsInput,
  Mention,
  SuggestionDataItem,
  OnChangeHandlerFunc,
} from 'react-mentions';
import mentionsInputStyle from './mentionsInputStyle';

interface IProps {
    data: SuggestionDataItem[];
    value: string;
    onChange: OnChangeHandlerFunc;
    required?: boolean;
    className?: string;
    placeholder?: string;
}

export const TaggingTextField: FC<IProps> = ({
    data,
    value,
    onChange,
    required,
    className,
    placeholder,
}) => {
    return (
        <MentionsInput
            required={required}
            className={className}
            style={mentionsInputStyle}
            placeholder={placeholder || ''}
            value={value}
            onChange={onChange}
            allowSpaceInQuery>
            <Mention
                trigger="@"
                data={data || []}
                displayTransform={(id, display) => `@${display}`}
                appendSpaceOnAdd
            />
        </MentionsInput>
  );
};

export default TaggingTextField;
